import React, { useMemo } from 'react';

const PATTERNS = {
  '0':'bsbSBsBsb','1':'BsbSbsbsB','2':'bsBSbsbsB','3':'BsBSbsbsb','4':'bsbSBsbsB','5':'BsbSBsbsb','6':'bsBSBsbsb','7':'bsbSbsBsB','8':'BsbSbsBsb','9':'bsBSbsBsb',
  A:'BsbsbSbsB',B:'bsBsbSbsB',C:'BsBsbSbsb',D:'bsbsBSbsB',E:'BsbsBSbsb',F:'bsBsBSbsb',G:'bsbsbSBsB',H:'BsbsbSBsb',I:'bsBsbSBsb',J:'bsbsBSBsb',
  K:'BsbsbsbSB',L:'bsBsbsbSB',M:'BsBsbsbSb',N:'bsbsBsbSB',O:'BsbsBsbSb',P:'bsBsBsbSb',Q:'bsbsbsBSB',R:'BsbsbsBSb',S:'bsBsbsBSb',T:'bsbsBsBSb',
  U:'BSbsbsbsB',V:'bSBsbsbsB',W:'BSBsbsbsb',X:'bSbsBsbsB',Y:'BSbsBsbsb',Z:'bSBsBsbsb','-':'bSbsbsBsB','.':'BSbsbsBsb',' ':'bSBsbsBsb','*':'bSbsBsBsb','$':'bSbSbSbsb','/':'bSbSbsbSb','+':'bSbsbSbSb','%':'bsbSbSbSb'
};

function normalize(value='') {
  return String(value).toUpperCase().replace(/[^0-9A-Z. $/+%\-]/g, '-').slice(0, 48);
}

export default function Code39Barcode({ value, height=76, narrow=2, ratio=2.5, showText=true, className='' }) {
  const code = normalize(value);
  const model = useMemo(() => {
    const encoded = `*${code}*`;
    let x = narrow * 10;
    const rects = [];
    encoded.split('').forEach((ch, charIndex) => {
      const pattern = PATTERNS[ch] || PATTERNS['-'];
      pattern.split('').forEach((token, i) => {
        const wide = token === token.toUpperCase();
        const width = narrow * (wide ? ratio : 1);
        const isBar = token.toLowerCase() === 'b';
        if (isBar) rects.push({ x, width, key:`${charIndex}-${i}` });
        x += width;
      });
      if (charIndex < encoded.length - 1) x += narrow;
    });
    return { rects, width:x + narrow * 10 };
  }, [code, narrow, ratio]);
  return <div className={`code39-wrap ${className}`}>
    <svg role="img" aria-label={`Barcode ${code}`} viewBox={`0 0 ${model.width} ${height}`} preserveAspectRatio="none" className="code39-svg">
      <rect x="0" y="0" width={model.width} height={height} fill="white" />
      {model.rects.map(r=><rect key={r.key} x={r.x} y="4" width={r.width} height={height-8} fill="black" />)}
    </svg>
    {showText&&<code className="code39-text">{code}</code>}
  </div>;
}
